import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core'
import { MatButton } from '@angular/material/button'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatIcon } from '@angular/material/icon'
import {
  ElderAutoSelectFirstDirective,
  ElderCardPanelComponent,
  ElderOverlayComponent,
  ElderOverlayOriginDirective,
  ElderOverlayTriggerDirective,
  ElderSelectComponent,
} from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { Observable } from 'rxjs'
import { Facility } from '../facility'
import { FacilitySelectDirective } from '../facility-select.directive'
import { FacilityService } from '../facility.service'

@Component({
  selector: 'app-facility-menu',
  templateUrl: './facility-menu.component.html',
  styleUrls: ['./facility-menu.component.scss'],
  imports: [
    MatButton,
    ElderOverlayOriginDirective,
    ElderOverlayTriggerDirective,
    MatIcon,
    ElderOverlayComponent,
    ElderCardPanelComponent,
    MatFormField,
    MatLabel,
    ElderSelectComponent,
    FacilitySelectDirective,
    ElderAutoSelectFirstDirective,
    AsyncPipe,
    ElderTranslatePipe,
  ],
})
export class FacilityMenuComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private facilityService = inject(FacilityService)

  @Input()
  public disabled = false

  /***************************************************************************
   *                                                                         *
   * Getters / Setters                                                       *
   *                                                                         *
   **************************************************************************/

  public get activeFacility$(): Observable<Facility> {
    return this.facilityService.activeFacility$
  }

  public set activeFacility(facility: Facility) {
    this.facilityService.setActiveFacility(facility)
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/
}
